"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.PathChecker = exports.PathGenerator = exports.PATH__TEST_UG = exports.PATH__ADMIN = exports.PATH__PROJECT_SETTINGS = exports.PATH__PROJECT_MEMBERS = exports.PATH__PROJECT_AUDIT = exports.PATH__PROJECT_PARAMETERS = exports.DEFAULT_PROJECT_SECTION = exports.PATH__PROJECT = exports.PATH__PROJECT_ROOT = exports.PATH__PROJECTS = exports.PATH__PROFILE = exports.PATH__LEGAL = exports.PATH__HOME = exports.PATH_BRAND_GUIDELINES = void 0;
const react_router_dom_1 = require("react-router-dom");
const query_string_1 = __importDefault(require("query-string"));
const constants_1 = require("src/configeek_assets/src/constants");
////////////////////////////////////////////////
// Anonymous
////////////////////////////////////////////////
exports.PATH_BRAND_GUIDELINES = "/brandGuidelines";
////////////////////////////////////////////////
// Common
////////////////////////////////////////////////
exports.PATH__HOME = "/";
exports.PATH__LEGAL = "/legal";
////////////////////////////////////////////////
// Authorized
////////////////////////////////////////////////
exports.PATH__PROFILE = "/profile";
exports.PATH__PROJECTS = "/projects";
exports.PATH__PROJECT_ROOT = "/project/:projectApiKey";
exports.PATH__PROJECT = `${exports.PATH__PROJECT_ROOT}/:section`;
exports.DEFAULT_PROJECT_SECTION = "parameters";
exports.PATH__PROJECT_PARAMETERS = `${exports.PATH__PROJECT_ROOT}/${"parameters"}`;
exports.PATH__PROJECT_AUDIT = `${exports.PATH__PROJECT_ROOT}/${"auditLog"}`;
exports.PATH__PROJECT_MEMBERS = `${exports.PATH__PROJECT_ROOT}/${"members"}`;
exports.PATH__PROJECT_SETTINGS = `${exports.PATH__PROJECT_ROOT}/${"settings"}`;
exports.PATH__ADMIN = "/admin";
exports.PATH__TEST_UG = "/test_ug";
exports.PathGenerator = {
    project: (projectApiKey, section = exports.DEFAULT_PROJECT_SECTION, serializedState) => {
        return query_string_1.default.stringifyUrl({
            url: (0, react_router_dom_1.generatePath)(exports.PATH__PROJECT, { projectApiKey: projectApiKey, section: section }),
            query: { state: serializedState ? JSON.stringify(serializedState) : undefined }
        });
    },
    github: {
        home: () => constants_1.URL_GITHUB
    }
};
exports.PathChecker = {
    isProjectSectionValid: (section) => {
        if (section) {
            switch (section) {
                case "parameters":
                case "auditLog":
                case "members":
                case "settings":
                    return true;
            }
        }
        return false;
    }
};
